<template>
    <div class="animated fadeIn unearnsettlefrm">        
        <b-card>
            <div slot="header">
                PBB (Payment Before Broadcast) Settlement - Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>

            <b-row>
                <b-col lg="4" class="settlement-data">
                    <b-input-group >
                        <b-input-group-prepend><label>Settlement Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.settleno" readonly></b-form-input>
                    </b-input-group>                        
                    <b-input-group >
                        <b-input-group-prepend><label>Settlement Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.tglsettl" type="date" :state="!$v.model.tglsettl.$error"></b-form-input>                                        
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                            <b-form-textarea :rows="3" :max-rows="6" v-model="model.settleuraian" :state="!$v.model.settleuraian.$error" ></b-form-textarea>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>PBB Unsettled</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="model.totalpbb" :precision="2" disabled></my-number>
                    </b-input-group>
                </b-col>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Payment Number</label></b-input-group-prepend>
                                <b-form-input v-model="pbb.paymno" readonly></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuArsetShow=true">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>                        
                        </b-col>   
                        <b-col lg="5">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Payment Date</label></b-input-group-prepend>
                                <b-form-input v-model="pbb.tglpaym" type="date" disabled ></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input  v-model="pbb.uraian" readonly></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col lg="7">
                            <!-- <b-input-group>
                                <b-input-group-prepend><label>Receipt From</label></b-input-group-prepend>
                                <b-form-input readonly v-model="pbb.custinfo" ></b-form-input>
                            </b-input-group> -->
                            <b-input-group >
                                <b-input-group-prepend><label>Receipt From</label></b-input-group-prepend>
                                <b-form-input readonly v-model="pbb.custinfo" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuCustomerShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">      
                        <b-input-group>
                            <b-input-group-prepend class="d-md-inline d-lg-none"><label>Receive Method</label></b-input-group-prepend>
                            <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Receive Method</span></b-input-group-prepend>
                            <b-form-input readonly v-model="pbb.jenis" ></b-form-input>
                                <b-form-input v-model="pbb.nomorcek" readonly v-if="((pbb.jenis==='Cheque') || (pbb.jenis==='Giro'))"></b-form-input>
                        </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-row>
                        <b-col lg="8">
                            <b-input-group >
                                <b-input-group-prepend><label>Destination Bank</label></b-input-group-prepend>
                                <b-form-input readonly v-model="pbb.namabank"></b-form-input>
                                <b-input-group-append>
                                    <span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span>
                                </b-input-group-append>
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Bank Account No.</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Bank Account#</span></b-input-group-prepend>
                                <b-form-input disabled v-model="pbb.nomorrek"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="4">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Efective Date</label></b-input-group-prepend>
                                <b-form-input v-model="pbb.tgl_terima" type="date" disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.totalbyr" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="3">
                            <b-input-group >
                                <b-input-group-prepend><label>Bank Charges</label></b-input-group-prepend>
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.bcharges" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="4">
                            <b-input-group v-if="(pbb.matauang !== uanguser)">
                                <b-input-group-prepend><label>Exch. Rate {{pbb.matauang || ''}}</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.kurstrx" :precision="6" disabled></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-col>    
            </b-row>            
            <label><strong>Detail Invoice Settlement</strong></label>
            <b-card no-body class="mt-0">
                <b-table
                    class="mb-0"
                    ref="tblArpaymdt"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="arpaymdt.items"
                    :fields="arpaymdt.fields"
                    :current-page="arpaymdt.page"
                    :per-page="arpaymdt.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaibyr)="data">
                        {{data.item.nilaibyr|numFormat}}
                        </template>
                        <template v-slot:cell(kurskeAR)="data">
                        {{data.item.kurskeAR|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(kasdiskon)="data">
                        {{data.item.kasdiskon|numFormat}}
                        <div v-if="(data.item.Potongan)">{{data.item.Potongan}}</div>
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editArpaymdt(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delArpaymdt(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                    <b-row align-h="around">
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>AR Invoice No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="arpaymdtObj.invoiceno" @keyup.13.native="lkuArinvShow=true" :state="!$v.arpaymdtObj.arinvKey.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuArinvShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                <b-form-input v-model="arpaymdtObj.uraian" disabled></b-form-input>
                            </b-input-group>
                            <b-row no-gutters>
                                <b-col lg="7">
                                    <b-input-group >
                                        <b-input-group-prepend><label>Total Invoice</label></b-input-group-prepend>
                                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                        <my-number class="form-control text-right" v-model="arpaymdtObj.totalinv" :precision="2" disabled></my-number>
                                    </b-input-group>
                                </b-col>
                                <b-col lg="5">
                                    <b-input-group >
                                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>Outstanding</label></b-input-group-prepend>
                                        <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Outstanding</span></b-input-group-prepend>
                                        <b-input-group-prepend class="d-md-block  d-lg-none"><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                        <my-number class="form-control text-right" v-model="arpaymdtObj.outstand" :precision="2" disabled></my-number>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <b-row no-gutters>
                                <b-col lg="7">
                                    <b-input-group >
                                        <b-input-group-prepend><label>Not Posted Settl.Amt</label></b-input-group-prepend>
                                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                        <my-number class="form-control text-right" v-model="arpaymdtObj.byr_semu" :precision="2" disabled></my-number>
                                    </b-input-group>
                                </b-col>
                                <b-col lg="5">
                                    <b-input-group >
                                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>Not Posted Settl.Doc</label></b-input-group-prepend>
                                        <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Not Posted Settl.Doc</span></b-input-group-prepend>
                                        <b-form-input v-model="arpaymdtObj.byr_semu_doc" disabled></b-form-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <b-row no-gutters v-if="(arpaymdtObj.ttlpph)">
                                <b-col lg="7">
                                    <b-input-group>
                                        <b-input-group-prepend><label>PPH bisa dipotong</label></b-input-group-prepend>
                                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                        <my-number class="form-control text-right" v-model="arpaymdtObj.ttlpph" :precision="2" disabled></my-number>
                                        <b-input-group-prepend><span class="input-group-text">Pasal {{arpaymdtObj.pasalpph}}, tarif {{arpaymdtObj.pph}}%</span></b-input-group-prepend>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col lg="6">
                            <b-card no-body>
                                <b-tabs v-model="tabIndex">
                                    <b-tab title="Cash/Bank" active>
                                        <b-row no-gutters>
                                            <b-col lg="7">
                                                <b-input-group >
                                                    <b-input-group-prepend><label>Setttled Original Amt.</label></b-input-group-prepend>
                                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arpaymdtObj.nilaibyr" :precision="2" :state="!$v.arpaymdtObj.nilaibyr.$error"></my-number>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                        <b-row no-gutters>
                                            <b-col lg="7">
                                                <b-input-group >
                                                    <b-input-group-prepend><label>Setttled Cash/Bank Amt.</label></b-input-group-prepend>
                                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arpaymdtObj.nilaibank" :precision="2" :state="!$v.arpaymdtObj.nilaibank.$error"></my-number>
                                                </b-input-group>
                                            </b-col>
                                            <b-col lg="5">
                                                <b-input-group v-if="(model.matauang != arpaymdtObj.matauang)">
                                                    <b-input-group-prepend class="d-md-inline d-lg-none"><label>Rate {{model.matauang}} to {{arpaymdtObj.matauang}}</label></b-input-group-prepend>
                                                    <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text"> Rate {{model.matauang}} to {{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arpaymdtObj.kurskeAR" :precision="6" :state="!$v.arpaymdtObj.kurskeAR.$error"></my-number>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </b-tab>
                                    <b-tab title="Non Cash/Bank">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Jenis Potongan</label></b-input-group-prepend>
                                            <b-form-select v-model="arpaymdtObj.IDPotongan" :plain="true" :options="potongans" :state="!$v.arpaymdtObj.IDPotongan.$error"></b-form-select>
                                            <b-input-group-prepend><span class="input-group-text">tarif</span></b-input-group-prepend>
                                            <b-form-input v-model="arpaymdtObj.tarif" type="number" @change="calcPotongan()" ></b-form-input>
                                            <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                        </b-input-group>
                                        <b-input-group >
                                            <b-input-group-prepend><label>Nilai Potongan</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="arpaymdtObj.kasdiskon" :precision="2" ></my-number>
                                            <b-input-group-prepend><span class="input-group-text">in Original Amt.</span></b-input-group-prepend>
                                        </b-input-group>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </b-col>
                    </b-row>                            
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveArpaymdt()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>

                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-2">
                    <b-col lg="9">
                        <b-row >
                        <b-col cols="2">            
                            <b-button size="sm" class="ml-1" @click="addArpaymdt" :disabled="!(model.arpaymKey)">Add Settlement</b-button>                          
                        </b-col>
                        <b-col cols="10">
                            <div style="display: flex;margin:0;padding:0;">
                                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                                    Showing {{(arpaymdt.page - 1) * arpaymdt.limit + 1}}
                                    to <span v-if="((arpaymdt.page * arpaymdt.limit)>arpaymdt.total)">{{arpaymdt.total}}</span> <span v-else>{{arpaymdt.page * arpaymdt.limit}}</span>
                                    of {{arpaymdt.total}} entries,   <span class="mr-1">limit per page :</span> 
                                    <select  v-model="arpaymdt.limit"  style="width:60px;">
                                    <option>5</option>
                                    <option>10</option>
                                    <option>15</option>
                                    <option>20</option>                            
                                    <option>25</option>
                                    <option>30</option>                            
                                    <option>40</option>                            
                                    <option>50</option>                            
                                    <option>60</option>                            
                                    <option>70</option>                            
                                    <option>80</option>                            
                                    <option>90</option>                            
                                    </select>
                                </div>
                                <div>
                                    <b-pagination  class="ml-1" 
                                    align="left"
                                    :total-rows="arpaymdt.total"
                                    :per-page="arpaymdt.limit"
                                    v-model="arpaymdt.page"
                                    ></b-pagination>
                                </div>
                            </div>
                        </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="3">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:170px !importnat;" >Total Detail Settlement</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
                            </b-input-group>
                    </b-col>
                </b-row>
            </b-card>    
            <b-row class="justify-content-center mb-2">
                    <div style="width:450px;" class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                            <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                            <b-input-group-append>
                                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                            </b-input-group-append>
                            <b-input-group-append>
                                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>

            </b-row>
        </b-card>
        <b-modal v-model="lkuArinvShow" size="lg" :hide-footer="true" title="List of AR Invoice"  :key="model.custcode" :centered="true">
            <lku-arinv @click="onSelectLkuArinv" :customer="pbb.custinfo" :custcode="model.custcode" :formdata="lkuArInvData" :maxinvdate="maxinvdate" ></lku-arinv>
        </b-modal>        
        <b-modal v-model="lkuArsetShow" size="lg" :hide-footer="true" title="List of Payment - with Unearned Income " :centered="true">
            <lku-arset @click="onSelectLkuArset" :formdata="lkuArsetData"></lku-arset>
        </b-modal>       
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 130px;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuArset from "../lookup/lkuArsetUnearn";
import lkuArinv from "../lookup/lkuArinvLazzy2";
import lkuCustomer from "../lookup/lkuCustomer";
import dimension from "../../apis/dimension";
import arsettlement from '../../apis/arsettlement';
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, vDim, lkuArinv,lkuArset, lkuCustomer},
  mixins: [validationMixin],
  validations: {
        model: {
            arpaymKey: { required },
            settleuraian: { required },
            tglsettl: { required },
            // custcode: { required },
            settleamt: { required, minValue:minValue(0.01) },
            totalpbb: { required, minValue:minValue(0.00000001) }
        },
        arpaymdtObj :{
            arinvKey: { required },
            nilaibyr: { minValue:(function() {
                if (this.adaPotongan) {
                    return true;
                } else if ((this.arpaymdtObj.nilaibyr || 0 )<0.01){
                    return false;
                } else return true;
            }) },
            nilaibank: { minValue:(function() {
                if (this.adaPotongan) {
                    return true;
                } else if ((this.arpaymdtObj.nilaibank || 0 )<0.01){
                    return false;
                } else return true;
            }) },
            kurskeAR: { required, minValue:minValue(0.0000001) },  
            IDPotongan : { required:(function() {
                if (!this.adaPotongan) {
                    return true;
                } else if ((this.arpaymdtObj.IDPotongan || '')==''){
                    return false;
                } else return true;                
            }) },
        },
  }, 
  data() {
    return {
        arGroups : [],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
        isLoading: false,
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        lkuCustomerShow:false,
        model:{settleno:'',arpaymKey:'',totalpbb:0,tglsettl:'',settleamt:0, kurstrx:1, settleuraian:'', custcode:'', customer_id:''},
        pbb:{jenis:'Giro',kodecash:'',kodebank:'',kurstrx:1,tglpaym:'',tgl_terima:'', matauang:'',totalbyr:'', custcode:'', customer_id:''},
        lblExchRate:"Exch. Rate ",
        bankOnly:1,
        totalDtlPaym:0,
        unsttlpbb: 0,
        updateDimHdr:false,
        updateDimDtl:true,
        arpaymdt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "invoiceno",
                    thStyle: "width:150px",
                    label: "Invoice Number",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaibyr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurskeAR",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kasdiskon",
                    label: "Settlement NON Bank/Cash",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:80px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:120px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arpaymdtObj:{arinvKey:'', kodecash:'',IDPotongan:'', kasdiskon:'', nilaibank:'', nilaibyr:''},
        lkuArinvShow: false,
        lkuArInvData:{},
        lkuArsetShow:false,
        lkuArsetData:{},
        maxinvdate:'',
        tabIndex:0
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    adaPotongan(){
        return ((this.arpaymdtObj.kasdiskon || 0) != 0);
    },
    IDPotongan(){return this.arpaymdtObj.IDPotongan;},
    adaNilaiBank(){return ((this.arpaymdtObj.nilaibank || 0) != 0);},
  },
  watch: {
    IDPotongan: function(kode) {
        let pot = this.potongans.find(r => r.value===kode);
        if (pot){
            this.arpaymdtObj.Potongan=pot.text;
        }
    },    
    "arpaymdtObj.nilaibyr": function(newVal) {
        if (this.model.matauang==this.arpaymdtObj.matauang){
            this.arpaymdtObj.nilaibank=newVal;
        }
    },    
    "model.tglsettl": function(newVal) {
        this.maxinvdate=  (newVal) ? moment(newVal).endOf('month').format('YYYY-MM-DD') : '';
    }
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      this.model.tglsettl = moment().format('YYYY-MM-DD');

      if (this.$route.params.settleKey) {
          toastr.info('Loading Payment Detail, please wait')
          try {
            const [a,c,d,data] = await Promise.all([arsettlement.currency(),await arsettlement.argroup(),await arsettlement.potongan(),
                                    arsettlement.detail(this.$route.params)]) ;
            this.currency = a;
            this.arGroups = c;
            this.potongans = d;
            const row = data[0][0];
            this.saveEnabled=(row.posting === 0);
        for (var key in row) {
            this.pbb[key] = row[key];
        }
        this.pbb.tglpaym = row.tglpaym ? moment(row.tglpaym).format('YYYY-MM-DD') : '';
        this.pbb.tgl_giro = (row.tgl_giro) ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
        this.pbb.tgl_terima = (row.tgl_terima) ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
        this.model.custcode = this.pbb.custcode;
        this.model.customer_id = this.pbb.customer_id;
        this.model.settleKey=row.settleKey;
        this.model.settleno = row.settleno;
        this.model.matauang = row.matauang;
        this.model.settleuraian=row.settleuraian;
        this.model.totalpbb=row.totalpbb;
        this.unsttlpbb= this.model.totalpbb;
        this.model.arpaymKey=row.arpaymKey;
        this.model.settleamt=row.settleamt;
        this.model.arpaymKey=row.arpaymKey;
        this.model.tglsettl = (row.tglsettl) ? moment(row.tglsettl).format('YYYY-MM-DD') : '';

            this.arpaymdt.items = data[1];
            this.arpaymdt.total=this.arpaymdt.items.length;
            this.calcTotalDtlPaym();
            this.updateDimHdr = !this.updateDimHdr;
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,c,d] = await Promise.all([arsettlement.currency(),await arsettlement.argroup(),await arsettlement.potongan()]) ;
        this.currency = a;
        this.arGroups = c;
        this.potongans = d;
      }
  },
  methods: {
    onSelectLkuArset: async function (arsetData) {
        for (var key in arsetData.selected) {
            this.pbb[key] = arsetData.selected[key];
        }
        this.pbb.tglpaym = arsetData.selected.tglpaym ? moment(arsetData.selected.tglpaym).format('YYYY-MM-DD') : '';
        this.pbb.tgl_giro = (arsetData.selected.tgl_giro) ? moment(arsetData.selected.tgl_giro).format('YYYY-MM-DD') : '';
        this.pbb.tgl_terima = (arsetData.selected.tgl_terima) ? moment(arsetData.selected.tgl_terima).format('YYYY-MM-DD') : '';
        this.model.custcode = this.pbb.custcode;
        this.model.customer_id = this.pbb.customer_id;
        this.model.kurstrx=1;
        this.model.matauang = arsetData.selected.matauang;
        this.model.settleuraian=arsetData.selected.uraian;
        this.model.totalpbb=arsetData.selected.pbb_ost;
        this.model.arpaymKey=arsetData.selected.arpaymKey;
        this.unsttlpbb= this.model.totalpbb;
        this.lkuArsetData=arsetData;

        this.lkuArsetShow=false;
    },
    onSelectLkuCustomer: async function (_selected) {
        this.pbb.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.customer_id = _selected.customer_id;
        // const dim = this.dimension.find(d => d.RelatedObj=='customer');
        // if (dim) {
        //     this.model[`${dim.value}`] = _selected.CustCode;
        //     this.model[`${dim.value}Txt`] = _selected.CustName.trim();
        //     this.model[`${dim.value}Info`] = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        // }
        this.lkuCustomerShow=false;
    },

    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;            
        // const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        // if (opened) {
        //     toastr.warn('Detail Form Un Saved');
        //     return;
        // }
        this.model.settleamt=this.totalDtlPaym;
        this.model.kurstrx = this.pbb.kurstrx;
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;            
        } else if (this.totalDtlPaym > parseFloat(this.model.totalpbb)) {
            toastr.error('[Total Detail Settlement] is greater than [Unearned Inc. BALANCE]', "ERROR MESSAGE");
            this.isLoading=false;            
        } else {
            try {
            // this.model.TableName = 'arsttltt';
            //     const dimValResult = await dimension.validate(this.model);
            //     if (dimValResult.success) {
                    this.model.settleno = this.model.settleno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.custcodeb4=this.pbb.custcode;
                    row.customer_idb4=this.pbb.customer_id;
                    row.tglsettl = moment(row.tglsettl).format('YYYY-MM-DD');
                    let settl_amt=0;
                    let newArpaymdts = this.arpaymdt.items.reduce((newArr, item) => {
                        if ((item.arinvKey || '') != '') {
                            // item.kurspost = this.model.kurstrx;
                            settl_amt += item.nilaibank;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    row.settleamt=settl_amt;

                    row.arpaymdt = newArpaymdts;
                    const hasil= await arsettlement.save(row);
                    toastr.success(`Success, Trx.Number ${hasil.settleno}`, "Save PBB Settlement",10000);
                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.isLoading=false;            
                        // const jenis = this.model.jenis;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        // this.model.jenis = jenis;
                        // this.model.matauang= this.$store.state.user.matauang;
                        this.model.tglsettl = moment().format('YYYY-MM-DD');
                        this.arpaymdt.items = [];
                        this.arpaymdt.total=0;
                        this.calcTotalDtlPaym();
                        this.$v.model.$reset();
                    }


                // } else {
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message || 'Dimension validation error';
                //     toastr.error(msg, "ERROR MESSAGE");
                // }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.isLoading=false;            
            }

        }
    },
    closeArPayment: function(){
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addArpaymdt : function () {
        if ((this.unsttlpbb - this.totalDtlPaym)>0) {
            this.closeArPayment();
            const obj={_showDetails:true};
            this.arpaymdt.selected = obj;
            for (var key in this.arpaymdtObj) {
                this.arpaymdtObj[key] = '';
            }
            this.arpaymdtObj.kurskeAR=1;
            this.tabIndex = 0;
            this.arpaymdt.items.push(obj);
            this.arpaymdt.total=this.arpaymdt.items.length;
            setTimeout(() => {
                const bfore = this.arpaymdt.page;
                const after =Math.ceil((this.arpaymdt.total)/this.arpaymdt.limit);
                if (bfore != after){
                    this.arpaymdt.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.arpaymdt.total} items`,'Line/Detail',10000);
                }
            }, 100);    
            this.inputLineBerlanjut=1;

        } else {
            toastr.error('PBB UnSettled Amount can not be zero or less');
        }
    },
    editArpaymdt : function (obj,callback) {
        this.closeArPayment();
        this.arpaymdt.selected = obj;
        for (var key in this.arpaymdtObj) {
            this.arpaymdtObj[key] = '';
        }
        for (var key in obj) {
            this.arpaymdtObj[key] = obj[key];
        }
        setTimeout(() => {
            this.tabIndex = (this.adaNilaiBank) ? 0:1;            
        }, 200);
        this.inputLineBerlanjut=0;
        callback();
    },
    delArpaymdt: function (index) {
        if (index > -1) {
            // this.arpaymdt.items.splice(index, 1);
            const posisi = (this.arpaymdt.page-1)*this.arpaymdt.limit;
            this.arpaymdt.items.splice(posisi+index, 1);
        }
        this.arpaymdt.total=this.arpaymdt.items.length;
        this.calcTotalDtlPaym();
    },
    saveArpaymdt: function (callback) {
        if (!this.adaPotongan) this.arpaymdtObj.IDPotongan='';
        this.arpaymdtObj.nilaibyr = this.arpaymdtObj.nilaibyr || 0;
        this.arpaymdtObj.kasdiskon = this.arpaymdtObj.kasdiskon || 0;
                
        if (this.invalidArpaymdt) {
            console.log('validation : ', this.$v.arpaymdtObj);
            console.log('model obj : ',this.arpaymdtObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            let totInvSttl = this.arpaymdt.items.reduce((tot, item) => {
                            if (item.arinvKey == this.arpaymdtObj.arinvKey) {
                                tot + ((item.nilaibyr||0)+(item.kasdiskon||0));
                            }
                            return tot;
                        }, (this.arpaymdtObj.nilaibyr + this.arpaymdtObj.kasdiskon));
            if (this.arpaymdt.selected.arinvKey == this.arpaymdtObj.arinvKey)
                totInvSttl= totInvSttl -  ((this.arpaymdt.selected.nilaibyr||0) + (this.arpaymdt.selected.kasdiskon||0));

            // if ((this.arpaymdtObj.nilaibyr + this.arpaymdtObj.kasdiskon)>this.arpaymdtObj.outstand){
            // if (totInvSttl>this.arpaymdtObj.outstand){
            // if ((totInvSttl-this.arpaymdtObj.outstand) > 0.01) {
            if ((totInvSttl+(this.arpaymdtObj.byr_semu||0)-this.arpaymdtObj.outstand) > 0.01) {
                toastr.error('Settled Amount exceeds Outstanding Amount', "ERROR MESSAGE");
            } else {
                this.arpaymdtObj.selisihkurs = this.arpaymdtObj.nilaibank - (this.arpaymdtObj.nilaibyr * this.arpaymdtObj.kurskeAR);
                for (var key in this.arpaymdtObj) {
                    this.arpaymdt.selected[key] = this.arpaymdtObj[key];
                }
                this.calcTotalDtlPaym();
                this.arpaymdt.selected._showDetails=false;
                if (callback) callback();
                if (this.inputLineBerlanjut==1) {
                    this.addArpaymdt();
                    this.$v.arpaymdtObj.$reset();
                }
            }
       }
    },
    onSelectLkuArinv(invLookup) {
        this.arpaymdtObj.arinvKey=invLookup.selected.arinvKey;
        this.arpaymdtObj.invoiceno=invLookup.selected.invoiceno;
        this.arpaymdtObj.uraian=invLookup.selected.uraian;
        this.arpaymdtObj.matauang=invLookup.selected.matauang;
        this.arpaymdtObj.totalinv=invLookup.selected.totalinv;
        this.arpaymdtObj.outstand=invLookup.selected.outstand;
        if (invLookup.selected.outstand<(this.unsttlpbb - this.totalDtlPaym)) {
            this.arpaymdtObj.nilaibyr=invLookup.selected.outstand;
        } else {
            this.arpaymdtObj.nilaibyr=(this.unsttlpbb - this.totalDtlPaym);
        }
        this.arpaymdtObj.cashflow=invLookup.selected.cashflow;
        this.arpaymdtObj.kodecash=invLookup.selected.kodecash;
        this.arpaymdtObj.nilaidpp=invLookup.selected.nilaidpp;
        this.arpaymdtObj.ttlpph=invLookup.selected.ttlpph;
        this.arpaymdtObj.pasalpph=invLookup.selected.pasalpph;
        this.updateDimDtl2Hdr(invLookup.selected);
        if (this.arpaymdtObj.matauang.trim() == this.model.matauang.trim()) {
            this.arpaymdtObj.nilaibank=this.arpaymdtObj.nilaibyr;
            this.arpaymdtObj.kurskeAR = 1;
            this.arpaymdtObj.selisihkurs = 0;
        }
        this.lkuArinvShow=false;
        this.lkuArInvData=invLookup;
        arsettlement.byrsemu(invLookup.selected).then(result => {
                this.arpaymdtObj.byr_semu= result.byr_semu;
                this.arpaymdtObj.byr_semu_doc= result.byr_semu_doc;
            })
            .catch(err => {
                console.log('byrsemu -> ', err);
            });
    },

    calcPotongan : function() {
        let pot = this.potongans.find(r => r.value=== this.arpaymdtObj.IDPotongan);
        if (pot){
            if (pot.pajak) {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.nilaidpp * this.arpaymdtObj.tarif / 100;
            } else {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * this.arpaymdtObj.tarif / 100;
            }
        } else {
            this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * this.arpaymdtObj.tarif / 100;
        }
    },

    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        totalDtlPaym = totalDtlPaym || 0;
        this.arpaymdt.items.forEach( function (trx) {
            if (trx.arinvKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='receivable.pbbsettlefrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'receivable.pbbsettle'});
      }
    }
  }
};
</script>
